/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThreadV2.defs'
export { main as default } from './getPostThreadV2.defs'
